const VIEWPORT_MARGIN = 12;

export function getViewportShift(rect: DOMRect): number {
  if (rect.left < VIEWPORT_MARGIN) {
    return VIEWPORT_MARGIN - rect.left;
  }

  if (rect.right > window.innerWidth - VIEWPORT_MARGIN) {
    return window.innerWidth - VIEWPORT_MARGIN - rect.right;
  }

  return 0;
}
